import React from "react";
import BannerImg from "../../../assets/img/banner/banner.png";
import Element1 from "../../../assets/img/banner/element-1.png";
import Element2 from "../../../assets/img/banner/element-2.png";
import Element3 from "../../../assets/img/banner/element-3.png";
import { useCmsSection } from "../../../hooks/useCmsSection";

const defaultH1Html =
  '<span><span class="color_big">Culture,</span> education,</span> &amp; integration — with sport at the heart';

const defaultParagraphHtml =
  "PCF brings Pakistani families in Sweden together around heritage, learning, and building confidence in Swedish society. <strong>Badminton</strong> is our main sport; we also run swimming, cricket, and football at different times of year, plus social gatherings that strengthen community and integration.";

function escHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

const HomeBanner = () => {
  const { data } = useCmsSection("home_hero");

  const h1Html =
    data?.h1Html ||
    (data?.h1 != null && String(data.h1).trim() !== ""
      ? `<span>${escHtml(data.h1)}</span>`
      : defaultH1Html);

  const paragraphHtml =
    data?.paragraphHtml ||
    (data?.paragraph != null && String(data.paragraph).trim() !== ""
      ? escHtml(data.paragraph)
      : defaultParagraphHtml);

  return (
    <section id="home_one_banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="banner_one_text">
              <h1 dangerouslySetInnerHTML={{ __html: h1Html }} />
              <p dangerouslySetInnerHTML={{ __html: paragraphHtml }} />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner_one_img">
              <img src={BannerImg} alt="img" />
              <div className="banner_element">
                <img
                  src={Element1}
                  alt="icon"
                  className="element_1 shape-1"
                />
                <img
                  src={Element2}
                  alt="icon"
                  className="element_2 shape-2"
                />
                <img
                  src={Element3}
                  alt="icon"
                  className="element_3 shape-3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
